export const releaseName = process.env.RELEASE_NAME || 'unknown'
export const development = process.env.NODE_ENV === 'development'
